export var VERSION = __VERSION__;
//# sourceMappingURL=constants.js.map